import { Editor } from '@tiptap/react';

export function hasExtension(editor: Editor | null, extName: string) {
  if (!editor) return false;
  return Boolean(
    editor?.extensionManager?.extensions?.find((ext) => ext?.name === extName),
  );
}
